import React from 'react'
import { StaticImage } from "gatsby-plugin-image";

const RedCollar = () => {
  return (
    <StaticImage
    placeholder="blurred"
    src="../../../../../../../images/collar-perro-salud-kolyy.png"
    alt="collar inteligente kolyy"
  />
  )
}

export default RedCollar